<!-- 空列表状态 -->
<template>
  <div class="emptylist">
    <div class="content">
      <img class="content-image" src="@/assets/global/empty.png">
      <div class="content-text">空空如也</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmptyList',
  data() {
    return {
      
    }
  }
}
</script>

<style lang="less" scoped>
  .emptylist {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding-top: 4rem;
    .content {
      width: 100%;
      text-align: center;
      &-image {
        width: 3.2rem;
        height: 3.2rem;
      }
      &-text {
        color: #A0A0A6;
        font-size: .36rem;
      }
    }
  }
</style>
